export default __webpack_public_path__ + "static/media/add-step2.7dffa0ca.svg";